import { TABLE_AUTO_PAGINATION_THRESHOLD } from '../../../blockConfig';

// Table behaviour: normalization, alignment and pagination. config.pagination is
// tri-state: true/false force it on/off, null (the default) auto-enables it once
// the table exceeds AUTO_PAGINATION_THRESHOLD rows, as required by the CDA spec.
const AUTO_PAGINATION_THRESHOLD = TABLE_AUTO_PAGINATION_THRESHOLD;
const DEFAULT_PAGE_SIZE = 10;
const MIN_PAGE_SIZE = 1;
const MAX_PAGE_SIZE = 100;
const ALIGNMENTS = ['left', 'center', 'right'];

export default {
  props: {
    config: { type: Object, default: () => ({}) },
  },
  data() {
    return { currentPage: 1 };
  },
  computed: {
    headers() {
      const headers = this.config && this.config.headers;
      return Array.isArray(headers) ? headers.map(String) : [];
    },
    rows() {
      const rows = this.config && this.config.rows;
      if (!Array.isArray(rows)) return [];
      return rows
        .filter(row => Array.isArray(row))
        .map(row =>
          row.map(cell =>
            cell === null || cell === undefined ? '' : String(cell)
          )
        );
    },
    align() {
      return ALIGNMENTS.includes(this.config.align)
        ? this.config.align
        : 'left';
    },
    pageSize() {
      const size = Number(this.config.pageSize);
      if (!Number.isFinite(size)) return DEFAULT_PAGE_SIZE;
      return Math.min(Math.max(Math.round(size), MIN_PAGE_SIZE), MAX_PAGE_SIZE);
    },
    paginationEnabled() {
      if (this.config.pagination === true) return true;
      if (this.config.pagination === false) return false;
      // Auto (null/unset): decide from row count.
      return this.rows.length > AUTO_PAGINATION_THRESHOLD;
    },
    totalPages() {
      if (!this.paginationEnabled) return 1;
      return Math.max(1, Math.ceil(this.rows.length / this.pageSize));
    },
    visibleRows() {
      if (!this.paginationEnabled) return this.rows;
      const start = (this.currentPage - 1) * this.pageSize;
      return this.rows.slice(start, start + this.pageSize);
    },
  },
  methods: {
    goToPage(page) {
      this.currentPage = Math.min(Math.max(page, 1), this.totalPages);
    },
  },
};
